import React from 'react';

export const CloudDismiss = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M24 6C17.7093 6 12.5492 10.8405 12.0411 17H11.5C6.80558 17 3 20.8056 3 25.5C3 30.1944 6.80558 34 11.5 34H36.5C41.1944 34 45 30.1944 45 25.5C45 20.8056 41.1944 17 36.5 17H35.9589C35.4508 10.8405 30.2907 6 24 6Z"
      fill="url(#paint0_linear_378174_10293)"
    />
    <path
      d="M20 25.5C20 30.1944 16.1944 34 11.5 34C6.80558 34 3 30.1944 3 25.5C3 20.8056 6.80558 17 11.5 17C16.1944 17 20 20.8056 20 25.5Z"
      fill="url(#paint1_linear_378174_10293)"
      fillOpacity="0.3"
    />
    <path
      d="M24 30C30.6274 30 36 24.6274 36 18C36 11.3726 30.6274 6 24 6C17.7036 6 12.5398 10.8493 12.0397 17.0169C16.4826 17.2952 20 20.9869 20 25.5C20 26.755 19.728 27.9465 19.2397 29.0188C20.6991 29.6501 22.3087 30 24 30Z"
      fill="url(#paint2_linear_378174_10293)"
      fillOpacity="0.3"
    />
    <path
      d="M24 30C30.6274 30 36 24.6274 36 18C36 11.3726 30.6274 6 24 6C17.7036 6 12.5398 10.8493 12.0397 17.0169C16.4826 17.2952 20 20.9869 20 25.5C20 26.755 19.728 27.9465 19.2397 29.0188C20.6991 29.6501 22.3087 30 24 30Z"
      fill="url(#paint3_radial_378174_10293)"
    />
    <path
      d="M24 6C17.7093 6 12.5492 10.8405 12.0411 17H11.5C6.80558 17 3 20.8056 3 25.5C3 30.1944 6.80558 34 11.5 34H36.5C41.1944 34 45 30.1944 45 25.5C45 20.8056 41.1944 17 36.5 17H35.9589C35.4508 10.8405 30.2907 6 24 6Z"
      fill="url(#paint4_radial_378174_10293)"
      fillOpacity="0.5"
    />
    <path
      d="M24 6C17.7093 6 12.5492 10.8405 12.0411 17H11.5C6.80558 17 3 20.8056 3 25.5C3 30.1944 6.80558 34 11.5 34H36.5C41.1944 34 45 30.1944 45 25.5C45 20.8056 41.1944 17 36.5 17H35.9589C35.4508 10.8405 30.2907 6 24 6Z"
      fill="url(#paint5_radial_378174_10293)"
      fillOpacity="0.5"
    />
    <path
      d="M45 34C45 40.0751 40.0751 45 34 45C27.9249 45 23 40.0751 23 34C23 27.9249 27.9249 23 34 23C40.0751 23 45 27.9249 45 34Z"
      fill="url(#paint6_linear_378174_10293)"
    />
    <path
      d="M39.7071 29.7071C40.0976 29.3166 40.0976 28.6834 39.7071 28.2929C39.3166 27.9024 38.6834 27.9024 38.2929 28.2929L34 32.5858L29.7071 28.2929C29.3166 27.9024 28.6834 27.9024 28.2929 28.2929C27.9024 28.6834 27.9024 29.3166 28.2929 29.7071L32.5858 34L28.2929 38.2929C27.9024 38.6834 27.9024 39.3166 28.2929 39.7071C28.6834 40.0976 29.3166 40.0976 29.7071 39.7071L34 35.4142L38.2929 39.7071C38.6834 40.0976 39.3166 40.0976 39.7071 39.7071C40.0976 39.3166 40.0976 38.6834 39.7071 38.2929L35.4142 34L39.7071 29.7071Z"
      fill="url(#paint7_linear_378174_10293)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_378174_10293"
        x1="4.5"
        y1="11.25"
        x2="22.0787"
        y2="38.6453"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0FAFFF" />
        <stop offset="1" stopColor="#367AF2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_378174_10293"
        x1="3"
        y1="19.912"
        x2="14.4602"
        y2="30.0552"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#FCFCFC" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_378174_10293"
        x1="16.1932"
        y1="7.35"
        x2="19.3632"
        y2="23.8986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#FCFCFC" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_378174_10293"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.9777 25.65) rotate(-22.8826) scale(14.6589 13.0847)"
      >
        <stop offset="0.412409" stopColor="#2C87F5" />
        <stop offset="1" stopColor="#2C87F5" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_378174_10293"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.25 4.25) rotate(62.4447) scale(34.9921 259.97)"
      >
        <stop offset="0.5" stopColor="#DD3CE2" stopOpacity="0" />
        <stop offset="1" stopColor="#DD3CE2" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_378174_10293"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34 37) rotate(90) scale(16.5 17.0156)"
      >
        <stop offset="0.288462" stopColor="#0D1F69" />
        <stop offset="1" stopColor="#0D1F69" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_378174_10293"
        x1="26.4375"
        y1="24.375"
        x2="43.1667"
        y2="48.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F83F54" />
        <stop offset="1" stopColor="#CA2134" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_378174_10293"
        x1="29.431"
        y1="34.4569"
        x2="34.8143"
        y2="40.0546"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFDFD" />
        <stop offset="1" stopColor="#FECBE6" />
      </linearGradient>
    </defs>
  </svg>
);
